class CandleBundleOffer extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
    this.link = this.querySelector('[data-bundle-link]');
    document.addEventListener('variant:update', event => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      this.updateSize(event.detail?.resource?.id);
    }, { signal: this.abort.signal });
    this.link.addEventListener('click', () => {
      const id = new URLSearchParams(window.location.search).get('variant');
      if (id) this.updateSize(id);
    }, { signal: this.abort.signal });
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  updateSize(id) {
    const variant = this.variants.find(item => item.id === String(id));
    if (!variant) return;
    const url = new URL(this.link.href);
    if (['7oz', '10oz'].includes(variant.size)) url.searchParams.set('size', variant.size);
    else url.searchParams.delete('size');
    this.link.href = url.href;
  }
}

if (!customElements.get('cng-bundle-offer')) customElements.define('cng-bundle-offer', CandleBundleOffer);
